import { useQuery } from 'react-query';

import { postV2ApiCompanyIdInternationalTransfersValidateRecipient } from 'src/client/spendesk-api';

export function useValidateRecipient({
  companyId,
  clientReference,
  enabled,
}: {
  companyId: string;
  clientReference: string;
  enabled: boolean;
}) {
  return useQuery(
    ['validate-recipient', clientReference],
    async () => {
      const response =
        await postV2ApiCompanyIdInternationalTransfersValidateRecipient({
          path: {
            companyId,
          },
          body: {
            clientReference,
          },
        });

      return response.statusCode === 200;
    },
    {
      retry: false,
      refetchOnMount: false,
      staleTime: 1 * 1000 * 60,
      cacheTime: 1 * 1000 * 60,
      enabled,
    },
  );
}
